import { render, staticRenderFns } from "./OrderTypeSelector.vue?vue&type=template&id=10427d3c&scoped=true&"
import script from "./OrderTypeSelector.vue?vue&type=script&lang=js&"
export * from "./OrderTypeSelector.vue?vue&type=script&lang=js&"
import style0 from "./OrderTypeSelector.vue?vue&type=style&index=0&id=10427d3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10427d3c",
  null
  
)

export default component.exports